import { D as DataType } from './dataConstants-856cb1e9.js';
var isDefined = function (value) { return value != null; };
var isValid = function (predicate) { return function (t) { return predicate(t); }; };
// As of now, we only check if the current component supports string or not.
var isSupportedDataType = function (supportsString) { return function (_a) {
    var dataType = _a.dataType;
    return (supportsString && dataType === DataType.STRING) || dataType !== DataType.STRING;
}; };
var isNumberDataStream = function (stream) { return stream.dataType === DataType.NUMBER; };
var isNumber = function (val) { return typeof val === 'number'; };
var isMinimalStaticViewport = function (viewport) { return 'start' in viewport && 'end' in viewport; };
export { isDefined as a, isMinimalStaticViewport as b, isNumberDataStream as c, isSupportedDataType as d, isNumber as e, isValid as i };
